export default {
  socials: [],
  contacts: [],
  boundary: []
};
